export const getQueryKey = (containerId: string) => [
  'containers',
  'tracking-data',
  containerId,
];
